import InfoIcon from '@mui/icons-material/Info';
import { useSelector } from 'react-redux';

import { RootState } from '../../../../store';
import { FooterText } from '../footer-text/FooterText';

const YouCanComeBackNote: React.FC = () => {
  const isEmbedded = useSelector(({ portal }: RootState) => portal.isEmbedded);

  return (
    <FooterText
      icon={<InfoIcon fontSize="small" />}
      text={
        isEmbedded
          ? 'You can come back and resume your application at any time'
          : 'You can always come back and resume by logging in with your email/phone number'
      }
    />
  );
};

export { YouCanComeBackNote };
